// This originally comes from https://github.com/alexjoverm/v-lazy-image, specifically commit e00f2d3. I've modified it such that if you change the src, it'll show the placeholder again until the new src is loaded.
//
// It has another behavior that's probably tailored to my use case with Share My Scrapbook's PageTurner component. The problem is we don't know what size to show the thumbnails at. So what we do, if the src is changed, is to set the width and height attributes on the $el, and when the src is loaded, we remove them.
//
// It's this ability to change the src that I named this component 'ReLazy...'.

const ReLazyImageComponent = {
  props: {
    src: {
      type: String,
      required: true
    },
    srcPlaceholder: {
      type: String,
      default: ""
    },
    srcset: {
      type: String
    },
    intersectionOptions: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({ observer: null, intersected: false, loaded: false }),
  computed: {
    srcImage() {
      return this.intersected ? this.src : this.srcPlaceholder;
    },
    srcsetImage() {
      return this.intersected && this.srcset ? this.srcset : false;
    }
  },
  render(h) {
    return h("img", {
      attrs: { src: this.srcImage, srcset: this.srcsetImage },
      class: {
        "v-lazy-image": true,
        "v-lazy-image-loaded": this.loaded
      }
    });
  },
  mounted() {
    this.$el.addEventListener("load", () => {
      if (this.$el.getAttribute('src') !== this.srcPlaceholder) {
        this.$el.removeAttribute('width');
        this.$el.removeAttribute('height');
        this.loaded = true;
        this.$emit("load");
      }
    });

    this.loadObserver();
  },
  destroyed() {
    this.observer.disconnect();
  },
  watch: {
    src(newVal) {
      // If the image has previously been loaded, we don't need to lazy load it.
      // Reminder that this technique doesn't work if you do "Disable cache" in the DevTools.
      if (this.$el.complete) {
        return;
      }

      const rect = this.$el.getBoundingClientRect();
      this.$el.setAttribute('width', rect.width);
      this.$el.setAttribute('height', rect.height);
      this.intersected = false;
      this.loaded = false;
      this.loadObserver();
    },
  },
  methods: {
    loadObserver() {
      this.observer = new IntersectionObserver(entries => {
        const image = entries[0];
        if (image.isIntersecting) {
          this.intersected = true;
          this.observer.disconnect();
          this.$emit("intersect");
        }
      }, this.intersectionOptions);

      this.observer.observe(this.$el);
    }
  },
};

export default ReLazyImageComponent;

export const ReLazyImagePlugin = {
  install: (Vue) => {
    Vue.component("ReLazyImage", ReLazyImageComponent);
  }
};
